module.exports = __webpack_public_path__ + "static/media/view quiz info.b26114c5.svg";